import React from "react";

const CalendarIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
      {...props}
    >
      <rect
        x="10"
        y="20"
        width="100"
        height="90"
        rx="10"
        ry="10"
        fill="white"
        stroke="lightgray"
        strokeWidth="2"
      />
      <rect
        x="9"
        y="20"
        width="102"
        height="25"
        rx="4"
        ry="4"
        fill="#ea4335"
      />
      <rect x="25" y="10" width="6" height="20" rx="3" ry="3" fill="#3c3c3c" />
      <rect x="57" y="10" width="6" height="20" rx="3" ry="3" fill="#3c3c3c" />
      <rect x="89" y="10" width="6" height="20" rx="3" ry="3" fill="#3c3c3c" />
      <g fill="#4285f4">
        <rect x="32" y="60" width="15" height="15" rx="3" />
        <rect x="52" y="60" width="15" height="15" rx="3" />
        <rect x="72" y="60" width="15" height="15" rx="3" />
        <rect x="32" y="80" width="15" height="15" rx="3" />
        <rect x="52" y="80" width="15" height="15" rx="3" />
        <rect x="72" y="80" width="15" height="15" rx="3" />
      </g>
    </svg>
  );
};

export default CalendarIcon;
